import React from "react";
import { Panel } from "cprime-foundational-components";
import FooterButtons from "./FooterButtons";
import ApiFooterButtons from "./ApiFooterButtons";

interface PanelComponentProps {
  open: boolean;
  title: string;
  onClose: () => void;
  BodyComponent: React.ReactNode;
  tabValue: number;
  isEdit: boolean;
  getApplicationDetails?: any;
}

const PanelComponent: React.FC<PanelComponentProps> = ({
  open,
  title,
  onClose,
  BodyComponent,
  tabValue,
  isEdit,
  getApplicationDetails,
}) => {
  const renderSlotComponent = () => {
    if (tabValue === 1) {
      return (
        <FooterButtons
          onCancel={onClose}
          isEdit={isEdit}
          getApplicationDetails={getApplicationDetails}
        />
      );
    } else if (tabValue === 2) {
      return (
        <ApiFooterButtons
          onCancel={onClose}
          isEdit={isEdit}
          getApplicationDetails={getApplicationDetails}
        />
      );
    }
    return null;
  };

  return (
    <div>
      <Panel
        id="panelStyle"
        sx={{
          "& .MuiDrawer-root": { padding: "0px" },
          "& #PanelBody": { paddingBottom: "0px" },
          "& .MuiPaper-root": {
            width: "800px",
            top: "104px",
            height: "calc(100vh - 104px)",
            gap: "24px",
          },
        }}
        open={open}
        title={title}
        side="right"
        onClose={onClose}
        body={
          <>
            {BodyComponent}
            {renderSlotComponent()}
          </>
        }
      />
      <span
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          width: "100vw",
          height: "calc(100vh - 104px)",
          zIndex: 1100,
          top: "104px",
          left: 0,
        }}
      ></span>
    </div>
  );
};

export default PanelComponent;
